import { Button, Image, Checkbox } from 'semantic-ui-react';
import {
  cancelThisWeekendService,
  thisWeekendService,
} from '../../../containers/experience/volunteersLogs/confirmationHelpers';
import { profileImage } from '../../helpers';
import { ShowGuestLeaders } from '../../../containers/membersLeader/showLeaders';

export const ExperienceTeamAreaRowDef = ({
  loading,
  service,
  eventSlugname,
  getVolunteersByEvent,
  set_loading,
  showImgs,
  isVolunteerReserved,
  isVolunteerChecked,
  handleCheckboxChange,
  handleSelectAll,
  volunteersRowChecks,
  volunteers,
  set_editingVolunteer,
  openVolLeaders,
  setOpenVolLeaders,
  showArea = false,
  showEdit = false,
  showActive = false,
  grouped = false,
  showLeaders = false,
  showDocs = false,
  showConvenio = false,
  showSubsection = false,
}) => {
  // Selection column
  const selectionColumn = {
    headerName: '',
    field: 'checkbox',
    width: 60,
    pinned: 'left',
    headerComponent: () => (
      <Checkbox
        checked={
          volunteersRowChecks?.length === volunteers?.filter((v) => !v.suspended)?.length &&
          volunteersRowChecks?.length > 0
        }
        onChange={handleSelectAll}
      />
    ),
    cellRenderer: (params) => {
      const { data } = params;
      const checked = isVolunteerChecked(data.id);
      return (
        <Checkbox
          checked={checked}
          disabled={loading || data.suspended}
          onChange={() => handleCheckboxChange(data)}
        />
      );
    },
    sortable: false,
    filter: false,
  };

  // Personal information columns
  const personalInfoColumns = [
    {
      headerName: 'Cédula',
      field: 'identification',
      valueGetter: (params) => params.data?.Guest?.identification,
      width: 120,
    },
    ...(showImgs
      ? [
          {
            headerName: 'Foto',
            field: 'photo',
            width: 100,
            cellRenderer: (params) => (
              <Image src={profileImage(params.data?.Guest)} rounded size="small" />
            ),
            sortable: false,
            filter: false,
          },
        ]
      : []),
    {
      headerName: 'Nombre',
      field: 'name',
      valueGetter: (params) => `${params.data?.Guest?.name} ${params.data?.Guest?.lastName}`,
      width: 200,
    },
    {
      headerName: 'Celular',
      field: 'phone',
      valueGetter: (params) => params.data?.Guest?.phone,
      width: 130,
    },
    ...(showLeaders
      ? [
          {
            headerName: 'Lideres',
            field: 'leaders',
            width: 110,
            cellRenderer: (params) => (
              <ShowGuestLeaders
                Guest={params.data?.Guest}
                buttonText="Ver"
                setOpenVolLeaders={(open) => {
                  setOpenVolLeaders(open ? params.data.id : null);
                }}
                openVolLeaders={params.data.id === openVolLeaders}
                getInfo={getVolunteersByEvent}
                set_loading={set_loading}
                loading={loading}
              />
            ),
            sortable: false,
            filter: false,
          },
        ]
      : []),
  ];

  // Service information columns
  const serviceInfoColumns = [
    ...(showArea
      ? [
          {
            headerName: 'Area',
            field: 'serviceArea',
            width: 150,
            valueGetter: (params) => params.data?.serviceArea?.replace(/_/g, ' '),
          },
        ]
      : []),
    {
      headerName: 'Rol',
      field: 'role',
      width: 150,
      valueGetter: (params) => params.data?.role?.replace(/_/g, ' '),
    },
    ...(showSubsection
      ? [
          {
            headerName: 'Subsección',
            field: 'subsection',
            width: 160,
            valueGetter: (params) => params.data?.subsection?.replace(/_/g, ' ') || '',
          },
        ]
      : []),
  ];

  // Status and management columns
  const statusColumns = [
    ...(showDocs
      ? [
          {
            headerName: 'Docs',
            field: 'documents',
            width: 80,
            valueGetter: (params) => {
              const { documentSideA, documentSideB } = params.data?.Guest || {};
              return documentSideA && documentSideB
                ? '2'
                : documentSideA || documentSideB
                ? '1'
                : '0';
            },
          },
        ]
      : []),
    ...(showConvenio
      ? [
          {
            headerName: 'Convenio',
            field: 'convenio',
            width: 100,
            valueGetter: (val) => `${val.data?.convenio ? 'Si' : 'No'}`,
          },
        ]
      : []),
    ...(showActive
      ? [
          {
            headerName: 'Activo',
            field: 'active',
            width: 100,
            valueGetter: (params) => (params.data?.suspended ? 'No' : 'Si'),
          },
        ]
      : []),
  ];

  // Action columns
  const actionColumns = [
    ...(showEdit
      ? [
          {
            headerName: 'Editar',
            field: 'edit',
            width: 100,
            cellRenderer: (params) => (
              <Button
                disabled={loading}
                size="small"
                onClick={() => set_editingVolunteer(params.data)}
              >
                Editar
              </Button>
            ),
            sortable: false,
            filter: false,
          },
        ]
      : []),
    {
      headerName: 'Sirve en este evento',
      field: 'service',
      width: 180,
      cellRenderer: (params) => {
        const volunteer = params.data;
        const volunteerReserved = isVolunteerReserved(volunteer.id);

        return volunteerReserved ? (
          <Button
            disabled={loading}
            size="small"
            onClick={() =>
              cancelThisWeekendService(
                [volunteer.id],
                service,
                eventSlugname,
                volunteer.Guest,
                getVolunteersByEvent,
                set_loading
              )
            }
          >
            Cancelar
          </Button>
        ) : (
          <Button
            disabled={loading}
            size="small"
            onClick={() =>
              thisWeekendService(
                [{ guest_id: volunteer.Guest.id, volunteer_id: volunteer.id }],
                service,
                eventSlugname,
                volunteer.Guest,
                getVolunteersByEvent,
                set_loading
              )
            }
            primary
          >
            Confirmar
          </Button>
        );
      },
      sortable: false,
      filter: false,
    },
  ];

  // Return grouped or flat structure
  if (grouped) {
    return [
      selectionColumn,
      {
        headerName: 'Información Personal',
        children: personalInfoColumns,
      },
      {
        headerName: 'Información de Servicio',
        children: serviceInfoColumns,
      },
      ...(statusColumns.length > 0
        ? [
            {
              headerName: 'Estado y Gestión',
              children: statusColumns,
            },
          ]
        : []),
      {
        headerName: 'Acciones',
        children: actionColumns,
      },
    ];
  }

  // Flat structure (original)
  return [
    selectionColumn,
    ...personalInfoColumns,
    ...serviceInfoColumns,
    ...statusColumns,
    ...actionColumns,
  ];
};
